<script lang="ts" setup>
import { computed, ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';

import { useModalsStore } from '@/stores/modals';
import { usePerformerStore } from '@/stores/performer';
import { useCamStore } from '@/stores/cam';
import { getStaticImages } from '@/utils';


const route = useRoute();
const { getByAdvert, loadPerformer, loadPerformerById } = usePerformerStore();
const { toggleModal, closeModal } = useModalsStore();

const router = useRouter();
const camStore = useCamStore();
const performerStore = usePerformerStore();

const performer: any = ref(undefined);

onMounted(load);

async function load() {
    await router.isReady();
    let p = getByAdvert(route.params.advert as any);
    if (p){
        performer.value = p;
    }
}

async function cancel(){
    await camStore.cancel();
    closeModal('loader');
}

</script>

<template src="./modal-loader.html"></template>
